export const GET_PRODUCT_QUERY: string = `
  query Get(
    $siteName: String!
    $ispreview: Boolean!
    $language: String!
    $configurationItem: String!
    $parameters: String!
    $selectedproductpimid: String!
    $additionalFilter: String
  ) {
    getCarSelectorProducts(
      siteName: $siteName
      ispreview: $ispreview
      language: $language
      configurationItem: $configurationItem
      parameters: $parameters
      selectedproductpimid: $selectedproductpimid
      additionalFilter: $additionalFilter
    ) {
      carSelectorProductsResponse
    }
  }
`;

export const GET_OPTIONS_QUERY: string = `
  query Get(
    $siteName: String!    
    $ispreview: Boolean!
    $language: String!
    $configurationItem: String!
    $parameters: String!
    $additionalFilter: String
  ) {
    getCarSelectorOptions(
      siteName: $siteName
      ispreview: $ispreview
      language: $language
      configurationItem: $configurationItem
      parameters: $parameters
      additionalFilter: $additionalFilter
    ) {
      carSelectorOptionsResponse
    }
  }
`;
